module.exports = __webpack_public_path__ + "static/img/xinba.0e419fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/xinba.jpg
// module id = 6P13
// module chunks = 1